import React from "react";

const hakimuddin_slatewala = () => {
  return (
    <div>
      <h1>Hakimuddin Slatewala</h1>

      <h4>
        <em>
          Computer Engineering, Batch of 27'
          <br />
          <hr />
        </em>
      </h4>

      <p>
        <strong>
          What was the criteria for shortlisting candidates in the initial
          stages of the recruitment process
        </strong>
        ?<br />
        For the Online Aptitude, all students with a CGPA greater than 7.5 were
        selected.
      </p>

      <p>
        <strong>What was the Timeline of the entire Interview Process</strong>?{" "}
      </p>

      <ol>
        <li>The Online Aptitude was scheduled on the 5th of September. </li>
        <li>
          All the Interview rounds (Technical Round 1 &amp; 2 and HR Round) were
          conducted on the 15th of September. The reason for the gap between the
          Online Aptitude and Interviews was mainly because of Midsems. The 2026
          batch did not have a gap after their Online Aptitude.
        </li>
      </ol>

      <p>
        <strong>What was the Structure of the Aptitude Round?</strong>
        <br />
        The Aptitude Round had 4 sections. Each section had a specific amount of
        time and you could not navigate through sections.
      </p>

      <ol>
        <li>
          Critical Section - This section had one coding question of medium
          difficulty. Questions were randomly allotted to students from a
          predefined question pool. I received a question based on Graph DFS.{" "}
        </li>
        <li>
          English Section - This section had 12 MCQs based on synonyms,
          prepositions, etc. Solving all the questions correctly would require a
          good command over the language.{" "}
        </li>
        <li>
          Business Section - This section had about 14 questions based on
          stock-chart reading and finance-based decision-making.{" "}
        </li>
        <li>
          Coding Section - This section had 2 easy questions.For the first
          question we were supposed to arrange a 1D array such that all the odd
          numbers are after the even numbers, in the same order. The second
          question was based on sorting.
        </li>
      </ol>

      <p>
        <strong>
          How many students were shortlisted after the Aptitude Round?
        </strong>
        <br />
        About 140 students appeared for the Aptitude Round and 25 were
        shortlisted for the Interviews. A few students had been rejected after
        the first technical interview, unfortunately, I do not remember the
        count. 10 students were finally shortlisted.{" "}
      </p>

      <p>
        <strong>
          After being shortlisted, how long was the wait time before the
          interviews began? During this period, what specific areas did you
          focus on to prepare effectively?
        </strong>
        <br />
        We received the shortlist email on the 11th of September. The interviews
        were scheduled on the 15th of September. We did have a gap of 4 days,
        but this was due to our Midsems. Our previous batch did not have a gap.
        <br />
        Our midsems ended on the 13th so I was mainly focusing on them. After
        they ended, I had about 1.5 days to prepare. During this period I mainly
        focused on revising my projects and how I should present them. Moreover,
        I focused on everything I had mentioned on my resume and also revised a
        bit of OS and CN.
      </p>

      <p>
        <strong>
          How many Interview Rounds were there for the company, can you
          elaborate about each round in brief? Also mention, how many students
          were shortlisted after each Interview Round?
        </strong>
        <br />
        There were 3 Interview Rounds in total. 2 Technical Rounds and 1 HR
        Round
        <br />
        Technical Round 1 - This round was conducted online. I was asked to
        share my screen and code a queue using a linked list. After that the
        interviewer asked me some basic questions regarding searching, sorting
        and various types of data structures(linear, non-linear). This round
        lasted about 45 minutes.
        <br />
        Technical Round 2 - This round was conducted offline. It was entirely
        resume based, that is why it is necessary to make sure that you are
        well-versed with everything you have put on your resume. The interviewer
        focused on System Design quite a lot and was constantly analysing my
        approach to solving problems. I was also asked questions about low-level
        languages, high-level languages, process memory, stack, heap, non-linear
        data structures and how they are stored in memory, Java, C,
        multi-threading and lastly I was asked to write the pseudo code of a
        question. It was an open-ended question where he asked me to write a
        scheduler algorithm for ‘n’ number of football teams playing against
        each other on different days in a Round-Robin fashion. I proposed a
        graph-based approach, and the interviewer later cross-questioned me on
        whether my solution could arrange both home and away matches. Since
        there wasn't enough time, the interviewer just asked me to explain my
        approach in depth. This round was about an hour long.
        <br />
        HR Round - This round was the shortest and lasted only 15 minutes.The
        interviewer started with the question, “Why Wells Fargo?”. I was later
        asked about my biggest failure and how I coped with it. I was also asked
        about how I manage my stress. Then, the interviewer asked me about my
        daily schedule. Lastly, he asked me about what my schedule would look
        like at Wells Fargo which gave me a slight hint that I might have been
        selected. At the end, I was asked whether I had any questions, make sure
        that you have a question or two to ask.{" "}
      </p>

      <p>
        <strong>
          What Topics or Skills did the interviewers focus on during the
          interviews? (e.g., DSA, Puzzles, DBMS, OS, Networks, System Design, or
          Behavioral questions)
        </strong>
        <br />
        In my case at least, the interviewers focused on DSA, OS, System Design,
        Multi-Threading, SDLC, Java, C and Assembly. The interviewer tested my
        confidence every now and then.
      </p>

      <p>
        <strong>
          What are some good resources that you used in your Internship Prep?
        </strong>
        <br />
        Strivers Sheet for DSA
        <br />
        3 Easy Pieces for OS
        <br />
        Silberschatz for DBMS
        <br />
        GFG for CN
      </p>

      <p>
        <strong>Some tips to crack Coding Questions?</strong>
        <br />I think the most important trick to crack coding questions is
        being as calm and composed as possible. Due to the time bound and
        nervousness, we often misunderstand coding problems and often stray away
        from what we are supposed to solve. My honest advice would be to read
        the question thoroughly and at least twice before you attempt it.
        Moreover, practising regularly is imperative to gaining an intuition to
        solve such questions.
      </p>

      <p>
        <strong>
          How many questions were asked about Projects, Clubs, and
          Extracurricular activities in your resume
        </strong>
        ?<br />
        Most of my second interview was based on a club I belong to since I
        spoke about the project and work I did there. I believe mentioning my
        extracurricular activities was the right thing to do as it helped me
        engage in a playful repartee with the interviewer and helped me build a
        rapport with him, which he happened to remember till the end of the
        interview.
      </p>

      <p>
        <strong>
          Is there something specific that you would want to tell people who are
          preparing for the same company
        </strong>
        ?<br />
        To get shortlisted for the interviews, It is necessary to perform well
        in the English and Business sections. The coding questions range from
        easy to medium difficulty, hence they are solved by most of the
        candidates. The business section acts as a game-changer, so take your
        time and understand the question before answering.
        <br />
        The CSI Diaries is a very good resource for understanding what
        interviewers and companies expect from us. At least in the case of Wells
        Fargo, I can surely say that each one of us had quite different
        experiences. So, go through them once to get a thorough understanding
        about the entire process.
      </p>

      <p>
        <strong>Any Final Tips for Juniors?</strong>
        <br />
        The entire process is very exhausting and stressful, but it is
        imperative to keep on working hard. Do not give up at any stage. Luck is
        a massive factor and heavily influences outcomes, so never beat yourself
        over short-term failures. Keep working till you get what you wish for.
        <br />
        The semester break after 2nd year is a blessing, so use it wisely. Also,
        try to be as consistent as you can and get used to working hard as it
        will help you go a very long way.
        <br />
        Interviews can be very stressful and nerve-wracking. I still remember
        how nervous I was before my interviews, but as soon as I sat on the
        chair for my first interview, the nervousness just vanished. The
        remainder of the process went by smoothly. Keep in mind that you can
        always steer interviews towards your strengths and interests.
        <br />
        Even if you experience stress, don't let it consume you; view it as a
        natural pressure that pushes you to perform at your best.
        <br />
        Lastly, I would like to emphasise on the fact that being consistent is
        key. Not only will it help you with your immediate goals, but it forms
        the foundation for long term achievements.{" "}
      </p>

      <p>
        <strong>Contact Info </strong>
        <br />
        <strong>Email :</strong> <a href="mailto:hakislate10@gmail.com">hakislate10@gmail.com</a>
        <br />
        <strong>LinkedIn :</strong>{" "}
        <a href="https://www.linkedin.com/in/hakimuddin-slatewala-53020b211/">
          Hakimuddin Slatewala
        </a>
      </p>

      <hr />
    </div>
  );
};

export default hakimuddin_slatewala;
